import { BottleOption, SizeOption, ProductProps } from "../Interfaces/Bottles";
import BottleCustomizationPage from "../components/Storefront/Bottles/CustomizeBottle";
import "./CustomizeBottle.css";
import { FundraiserParticipantShop } from "../Interfaces/FundraiserRole";
import { useEffect } from "react";

const CustomBottlePage = () => {

  useEffect(() => {
    document.title = "Bottle Customization";
  }, []);

  return (
    <div>
      <BottleCustomizationPage />
    </div>
  );
};

export default CustomBottlePage;
